import React from "react";
import { observer } from "mobx-react";
import { PublisherRepresentativeCreateStore } from "../../store";
import { PublisherRepresentativeCreateForm } from "./PublisherRepresentativeCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type PublisherRepresentativeCreateProps = {
  publisherRepresentativeCreateStore: PublisherRepresentativeCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PublisherRepresentativeCreate: React.FC<PublisherRepresentativeCreateProps> =
  observer(
    ({
      publisherRepresentativeCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={publisherRepresentativeCreateStore.isSaving} />
          <PublisherRepresentativeCreateForm
            publisherRepresentativeCreateStore={
              publisherRepresentativeCreateStore
            }
            nameError={publisherRepresentativeCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              publisherRepresentativeCreateStore.setNameValue(value);
            }}
            name={publisherRepresentativeCreateStore.entityValues.name}
            roleError={publisherRepresentativeCreateStore.errors.role?.message}
            onRoleChange={(value: string) => {
              publisherRepresentativeCreateStore.setRoleValue(value);
            }}
            role={publisherRepresentativeCreateStore.entityValues.role}
            emailError={
              publisherRepresentativeCreateStore.errors.email?.message
            }
            onEmailChange={(value: string) => {
              publisherRepresentativeCreateStore.setEmailValue(value);
            }}
            email={publisherRepresentativeCreateStore.entityValues.email}
            phoneError={
              publisherRepresentativeCreateStore.errors.phone?.message
            }
            onPhoneChange={(value: string) => {
              publisherRepresentativeCreateStore.setPhoneValue(value);
            }}
            phone={publisherRepresentativeCreateStore.entityValues.phone}
            isSignerError={
              publisherRepresentativeCreateStore.errors.isSigner?.message
            }
            onIsSignerChange={(value: boolean) => {
              publisherRepresentativeCreateStore.setIsSignerValue(value);
            }}
            isSigner={publisherRepresentativeCreateStore.entityValues.isSigner}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={publisherRepresentativeCreateStore.isProcessing}
            onSave={() =>
              publisherRepresentativeCreateStore.saveNewPublisherRepresentative()
            }
            onCancel={() =>
              publisherRepresentativeCreateStore.cancelNewPublisherRepresentative()
            }
          />
          <ErrorDialog
            open={publisherRepresentativeCreateStore.errorDialogOpened}
            title={publisherRepresentativeCreateStore.errorTitle}
            description={publisherRepresentativeCreateStore.errorDescription}
            onClose={() =>
              publisherRepresentativeCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
